import {
  Component,
  OnInit,
  ViewChild,
  SimpleChanges,
  Input,
  ElementRef,
  Output,
  EventEmitter,
} from "@angular/core";
import {
  Chart,
  ChartConfiguration,
  ChartEvent,

} from "chart.js";
import { BaseChartDirective } from "ng2-charts";
import * as _ from "lodash";
import { FiltersService } from "src/app/core/services/filters.service";
import { ServiceInsightsService } from "../../services/service-insights-service.service";
import { ServiceInsightRecord, ByLocationMetrics, ServiceInsightsCallData, ServiceInsightsByLocationData, SICallTypes, ServiceMetricTypes, ServiceInsightsObservationsData, ServiceInsightsObsByLocationData  } from "../../types/service-insight-types";
import { MetricsService } from "src/app/core/services/metrics.service";

import Annotation from "chartjs-plugin-annotation";
import { ContractModel } from "src/app/global/contract-filter-model";
import { Subscription } from "rxjs";
import { ServiceCustomerFilterOptions } from "src/app/global/service-customer-model";

/**
 * @deprecated
 * This component is deprecated and will be removed in future versions once refreshed UI is implemented in favor of @see ServiceDetailsMetricCardComponent.
 */
@Component({
    selector: "app-service-details-common-chart",
    templateUrl: "./service-details-common-chart.component.html",
    styleUrls: ["./service-details-common-chart.component.scss"],
    standalone: false
})
export class ServiceDetailsCommonChartComponent
  implements OnInit
{
  @Input() title: string = "Title";
  @Input() callType: SICallTypes = SICallTypes.UntrackedCalls;
  @Input() groupByProperty: string = "";
  @Input() serviceType: ServiceMetricTypes = ServiceMetricTypes.Calls; //either 'calls' or 'observations';

  @Output() toolTipClicked = new EventEmitter<any>();

  filters: ContractModel | undefined;

  DateData: ServiceInsightRecord[] = [];
  locationsData: ByLocationMetrics[] = []
  growth: number = 0;
  growthPositive: boolean = true;
  growthDateRangeAvailable : boolean = false;
  totalCount: number = 0;

  displayLoader: boolean = false;
  xAxis: string[] = [];
  yAxis: number[] = [];
  
  ChartOptions: ChartConfiguration["options"] = {};
  ChartType: ChartConfiguration["type"] = "line";
  ChartData: any;


  isOnInitCalled = false;
  toolTipData = {};

  selectedAdvancedFilters: ServiceCustomerFilterOptions = {
    "accountNumber": [],
    "accountName": [],
    "country": [],
    "state": [],
    "city": [],
    "zipCode": [],
    "recurringIssue": [],
   };

  serviceCustomerFiltersSubscription: Subscription| undefined;

  metricType : ServiceMetricTypes = ServiceMetricTypes.Calls;

  constructor(
    private _filterService: FiltersService,
    private _serviceInsightsService: ServiceInsightsService,
    private _metricsService: MetricsService,
  ) {}

  async ngOnInit() {
    if(this.callType == SICallTypes.PhotoObservations || this.callType == SICallTypes.VirtualAssistCalls) {
      this.metricType = ServiceMetricTypes.Observations;
    }

    this.selectedAdvancedFilters = {
      "accountNumber": [],
      "accountName": [],
      "country": [],
      "state": [],
      "city": [],
      "zipCode": [],
      "recurringIssue": [],
     };

    if (Chart) { Chart.register(Annotation); }
  
    this._filterService.selectedFiltersObservable.subscribe((f) => (this.filters = f));

    if (this.filters !== undefined) {
      this.displayLoader = true;

      this.subscribeToData();
      await this.loadData();

      this.serviceCustomerFiltersSubscription = this._serviceInsightsService.getServiceCustomerFilters().subscribe(async advFilter => {
        this.displayLoader = true;
        this.selectedAdvancedFilters = advFilter;
        this.loadData(true);
        this.displayLoader = false;
      });
        
      this.displayLoader = false;
      this.isOnInitCalled = true;
    }
  }

  private subscribeToData() {
    if(this.metricType == ServiceMetricTypes.Calls){
      this._serviceInsightsService.getServiceInsightsCallData(this.callType as keyof ServiceInsightsCallData).subscribe(
        (d) => {
          this.DateData = d.periods;
          this.growth = d.percentChangeInCount
        }
      );

      this._serviceInsightsService.getServiceInsightsLocationData(this.callType as keyof ServiceInsightsByLocationData).subscribe(
        (d) => {
          this.locationsData = d
        }
      );
    } else if(this.metricType == ServiceMetricTypes.Observations){
      this._serviceInsightsService.getServiceInsightsObsData(this.callType as keyof ServiceInsightsObservationsData).subscribe(
        (d) => {
          this.DateData = d.periods;
          this.growth = d.percentChangeInCount
        }
      );

      this._serviceInsightsService.getServiceInsightsLocationData(this.callType as keyof ServiceInsightsByLocationData).subscribe(
        (d) => {
          this.locationsData = d
        }
      );
    }
    
  }

  private async loadData(refresh = false) {
      
      if (refresh) {
        this.DateData = [];
        this.growth = 0;
        this.locationsData = [];
      }

      if(this.metricType == ServiceMetricTypes.Calls){
        if ((this.DateData != undefined && this.isEmptyData(this.DateData)) || refresh) {
          const response = await this._serviceInsightsService.getSIMetricByPeriodFromAPI(this.serviceType, this.callType, this.selectedAdvancedFilters);
          this._serviceInsightsService.setServiceInsightsCallData(this.callType as keyof ServiceInsightsCallData, response);
        }

        if ((this.locationsData != undefined && this.locationsData.length == 0) || refresh) {
          const response = await this._serviceInsightsService.getSIMetricByLocationFromAPI(this.serviceType, this.callType, this.selectedAdvancedFilters);
          this._serviceInsightsService.setServiceInsightsLocationData(this.callType as keyof ServiceInsightsByLocationData,
            response as ByLocationMetrics[]
          )
        }
      } else if(this.metricType == ServiceMetricTypes.Observations){
         if ((this.DateData != undefined && this.isEmptyData(this.DateData)) || refresh) {
          const response = await this._serviceInsightsService.getSIMetricByPeriodFromAPI(this.serviceType, this.callType, this.selectedAdvancedFilters);
          this._serviceInsightsService.setServiceInsightsObsData(this.callType as keyof ServiceInsightsObservationsData, response);
        }

        if ((this.locationsData != undefined && this.locationsData.length == 0) || refresh) {
          const response = await this._serviceInsightsService.getSIMetricByLocationFromAPI(this.serviceType, this.callType, this.selectedAdvancedFilters);
          this._serviceInsightsService.setServiceInsightsLocationData(this.callType as keyof ServiceInsightsByLocationData,
            response as ByLocationMetrics[]
          )
        }

      }

      this.totalCount = this.DateData.reduce((sum, current) => sum + current.total, 0); // Getting total count across all days in this period
      this.setGrowth();
      this.growthDateRangeAvailable = this._filterService.IsPreviousPeriodAvailable();

      if (
        (this.DateData && !this.isEmptyData(this.DateData)) ||
        (this.locationsData && this.locationsData.length > 0) ||
        refresh
      ) {
        if (this.groupByProperty === 'endDate') {
          this._fillXandYAxis(this.DateData, this.groupByProperty); // Uses this.DateData
          this.setOptions();
        } else if (this.groupByProperty === 'accountNumber') {
          this._fillXandYAxis(this.locationsData, this.groupByProperty); // Uses this.locationsData
          this.setOptions();
        }
      }
  }

  private _fillXandYAxis(data: any[], property: string) {
    this.xAxis = data.map(row => row[property]);
  
    if (property === "endDate") {
      this.toolTipData = data.map(record => ({
        total: record.total,
        endDate: record.endDate,
        totalLocations: record.totalLocations,
      }));
      this.yAxis = data.map(record => record.total);
    } else {
      this.toolTipData = data.map(record => ({
        totalCalls: record.totalCalls,
        location: record.accountName,
        accountNumber: record.accountNumber,
        recurringIssues: record.recurringIssues,
      }));
      this.yAxis = data.map(record => record.totalCalls);
    }
  }

  isEmptyData(data: ServiceInsightRecord[]) {
    return data.length == 0;
  }

  async ngOnChanges(changes: SimpleChanges) {
    // Check if ngOnInit has already been called
    if (this.isOnInitCalled) {
      if (this.DateData && this.groupByProperty == "endDate") {
        this._fillXandYAxis(this.DateData, this.groupByProperty);
        this.setOptions();
      } else if (
        this.locationsData &&
        this.groupByProperty == "accountNumber"
      ) {
        this._fillXandYAxis(this.locationsData, this.groupByProperty);
        this.setOptions();
      }
    }
  }

  calculateBarWidth(dataLength: number): number {
    const minWidth = 2; // min and max bar width in pixels
    const maxWidth = 8;
    const maxDataPoints = 300;

    // Calculate the percentage of data points relative to the maximum
    const percentage = dataLength / maxDataPoints;
    const widthRange = maxWidth - minWidth;

    // Calculate the expected bar width
    const calculatedWidth = maxWidth - widthRange * percentage;

    // Make sure the calculated width is within the specified range
    return Math.min(maxWidth, Math.max(minWidth, calculatedWidth));
  }

  setGrowth() {
      this.growthPositive = this.growth >= 0;
      this.growth = Math.abs(this.growth);
  }

  externalTooltipHandler(context: any) {
    // Extract necessary information from the context
    const { chart, tooltip, dataIndex } = context;
  
    // Fetch or create the tooltip element
    let tooltipEl = chart.canvas.parentNode?.querySelector("#chart-js-tooltip");
  
    if (!tooltipEl) {
      tooltipEl = document.createElement("div");
      tooltipEl.id = "chart-js-tooltip";
      tooltipEl.style.cssText = `
        background: rgba(255, 255, 255);
        border-radius: 3px;
        color: black;
        opacity: 1;
        position: absolute;
        transform: translate(-50%, 0);
        transition: all .1s ease;
      `;
  
      const table = document.createElement("table");
      table.style.margin = "0";
  
      tooltipEl.appendChild(table);
      chart.canvas.parentNode.appendChild(tooltipEl);
    }
  
    // Hide tooltip if it's not visible
    if (tooltip.opacity === 0) {
      tooltipEl.style.opacity = '0';
      return;
    }
  
    // Extract data for the current data point and set the tooltip text accordingly
    const currentObject = context.tooltip.dataPoints[0].dataset.toolTipData[tooltip.dataPoints[0].dataIndex];
  
    // Set Text
    if (tooltip.body) {
      const bodyLines = tooltip.body.map((b: any) => b.lines);
      const tableRoot = tooltipEl.querySelector("table");
  
      // Remove old children
      while (tableRoot.firstChild) {
        tableRoot.removeChild(tableRoot.firstChild);
      }
  
      // Add new children based on the location
      if (this.groupByProperty === "accountNumber") {
        const tooltipEle = document.createElement("div");
        tooltipEle.setAttribute('id', 'account-number-tooltip');
        tooltipEle.innerHTML = `
          <div style="font-size: 12px; color: #8E9393; padding-bottom: 5px">
            <span style="font-size: 30px; font-family: Roboto; font-weight: 400; color: #313233">${currentObject["totalCalls"]}</span> total calls
          </div>
          <div style="font-size: 12px; color: #313233; text-transform: capitalize;">${currentObject["location"]}</div>
          <div style="font-size: 12px; color: #313233;">${currentObject["accountNumber"]}</div>
          <div style="font-size: 12px; color: #8E9393;">
            <img style="vertical-align: text-top;" width="11" height="14" src="assets/recurring-icon.svg">
            <span style="color: #313233;">${currentObject["recurringIssues"]}</span> recurring issues
          </div>
        `;
        tableRoot.appendChild(tooltipEle);
      } 
      else if (this.groupByProperty === "endDate") {
        // Add new children based on the endDate
        const tooltipEle = document.createElement("div");
        tooltipEle.setAttribute('id', 'end-date-tooltip');
        tooltipEle.innerHTML = `
          <div style="display:flex; align-items:bottom; gap:8px;">
            <span class="total-calls-tooltip" style="font-size:30px; color:#313233;">${currentObject["total"]}</span>
            <span style="font-size:12px; color:#8E9393">total calls</span>
          </div>
          <br/>
          <span style="color:#313233; font-weight:400; font-family:Roboto;">${new Date(currentObject["endDate"]).toLocaleDateString('en-US', {month: "long", day: "numeric", year: "numeric"})}</span><br/>
          across ${currentObject["totalLocations"]} locations
        `;
        tableRoot.appendChild(tooltipEle);
      }
    }
  
    // Calculate the position and display the tooltip
    const { offsetLeft: positionX, offsetTop: positionY } = chart.canvas;
    
    tooltipEl.style.opacity = "1";
    tooltipEl.style.left = positionX + tooltip.caretX + 80 + "px";
    tooltipEl.style.top = "50%";
    tooltipEl.style.font = tooltip.options.bodyFont.string;
    tooltipEl.style.padding = tooltip.options.padding + "px " + tooltip.options.padding + "px";
  }

  setOptions() {
    // bar graph for location
    if (this.groupByProperty == "accountNumber") {
      this.ChartType = "bar";
      this.ChartData = {
        labels: this.xAxis,
        datasets: [
          {
            data: this.yAxis,
            barThickness: this.calculateBarWidth(this.yAxis.length),
            minBarThickness: 2,
            maxBarThickness: 8,
            fill: "origin",
            borderRadius: 4,
            toolTipData: this.toolTipData,
            backgroundColor: "rgba(26, 165, 224, 1)",
            hoverBackgroundColor: "rgba(26, 165, 224, 1)"
          },
        ],
      };

      this.ChartOptions = {
        interaction: {
          mode: "index",
          intersect: false,
        },
        maintainAspectRatio: false,
        scales: {
          y: {
            stacked: true,
            grid: {
              display: true,
              color: "rgba(224, 230, 241, 1)",
            },
            display: true,
            beginAtZero: true,
            ticks: {
              stepSize: Math.ceil(Math.max(...this.yAxis) / 6), 
            },
          },
          x: {
            grid: {
              color: "rgba(0, 0, 0, 0)",
            },
            display: false,
          },
        },
        plugins: {
          legend: {
            display: false,
          },
          annotation: {
            annotations: {
              averageLine: {
                type: "line",
                scaleID: "y",
                value: 10,
                borderColor: "rgb(75, 192, 192)",
                borderWidth: 0.5,
              },
            },
          },
          tooltip: {
            enabled: false,
            position: "nearest",
            external:  (ctx : any) => this.externalTooltipHandler(ctx)  ,
          },
        },
      };

    } else {
      // line graph for end Date
      this.ChartType = "line";
      this.ChartData = {
        labels: this.xAxis,
        datasets: [
          {
            data: this.yAxis,
            backgroundColor: "rgb(205, 235, 247)",
            borderColor: "rgb(76 172 229)",
            fill: "origin",
            toolTipData: this.toolTipData,
            borderWidth: 2 // Set the border width here

          },
        ],
      };
      
      this.ChartOptions = {
        maintainAspectRatio: false,
        elements: {
          point: {
            radius: 0,
            hoverRadius: 0 
          },
        },
        interaction: {
          mode: "index",
          intersect: false,
        },
        scales: {
          y: {
            stacked: true,
            grid: {
              color: "rgba(0, 0, 0, 0)",
            },
            display: false,
            beginAtZero: true,
          },
          x: {
            grid: {
              color: "rgba(0, 0, 0, 0)",
            },
            display: false,
          },
        },
        plugins: {
          legend: {
            display: false,
          },
          tooltip: {
            enabled: false,
            external: (ctx : any) => this.externalTooltipHandler(ctx)          },
        },
      };
    }
  }

  @ViewChild(BaseChartDirective) chart?: BaseChartDirective;

  private drawDashedLine(ctx: CanvasRenderingContext2D, x: number, canvasHeight: number) {
    ctx.save();
    ctx.setLineDash([5, 5]);
    ctx.beginPath();
    ctx.moveTo(x, 0);
    ctx.lineTo(x, canvasHeight);
    ctx.strokeStyle = '#E0E0E0';
    ctx.stroke();
    ctx.restore();
  }

  public ChartHovered({
    event,
    active,
  }: {
    event?: ChartEvent;
    active?: any;
  }): void {
    const chart = this.chart?.chart;
    const ctx = chart?.ctx;

    if (active && active.length) {
      const xValue = active[0]?.element?.x;
      if (_.isNumber(xValue) && ctx) {
        const canvasHeight = ctx.canvas.height;
        this.drawDashedLine(ctx, xValue, canvasHeight);
      }
    }
  }

  public chartClicked({
    event,
    active,
  }: {
    event?: ChartEvent; // Event associated with the chart click
    active?: any; // Array of active elements on the chart
  }): void {
    if (active.length === 0) {
      return; 
    }
    const mouseY = event?.y; // Get the y-coordinate of the click event
    const yPosOnChart = active[0]?.element?.y; // Get the y-coordinate of the active element on the chart

    if (!_.isNumber(mouseY) || mouseY <= yPosOnChart) {
      this.toolTipClicked.emit(""); // Emit an empty tooltip event if the click is above or at the same level as the active element
      return;
    }

    const currentIndex = active[0]?.index ?? -1; // Get the index of the active element
    let currentDataFilter: any = {}; // Initialize variable to store current data filter

    if (this.groupByProperty == "accountNumber") {
      currentDataFilter = this.locationsData[currentIndex] ?? {}; // Get data for a specific location
      sessionStorage.setItem("currentDataFilter", JSON.stringify(currentDataFilter?.accountName ?? "")); // Store the current data filter in session storage
      this.toolTipClicked.emit(currentDataFilter?.accountName ?? ""); // Emit the account name for the tooltip
    } else {
      currentDataFilter = this.DateData[currentIndex] ?? {}; // Get data for a specific index
      const endDate = currentDataFilter?.endDate?.match(/\d{4}-\d{2}-\d{2}/)![0] ?? ""; // Extract the end date from the data
      sessionStorage.setItem("currentDataFilter", JSON.stringify(endDate)); // Store the current data filter in session storage
      this.toolTipClicked.emit(endDate); // Emit the end date for the tooltip
    }
  }

  ngOnDestroy(): void {
    this.serviceCustomerFiltersSubscription?.unsubscribe();
  }
}

